<template>
  <v-app class="pro-theme">
    <v-navigation-drawer app color="dark" dark mini fixed style=" overflow: visible!important;transform:translateX(0%);"
      class="pb-6" :mini-variant="drawer" :permanent="!drawer" v-if="false" width="300">

      <!-- Logo img header -->
      <v-list-item class="px-3 mt-6">
        <v-list-item-avatar size="35">
          <v-img alt="Logo" cover src="/icons/large-icon.png" />
        </v-list-item-avatar>
      </v-list-item>
      <v-list>
        <v-list-item-group>
          <v-list-item v-for="(item, i) in items" :to="item.to || ''" :title="item.title" exact
            exact-active-class="primary--text" @click="item.title === 'logout' ? logout() : ''" :key="i" link>
            <v-list-item-icon>
              <v-icon :color="item.title === 'logout' ? 'error' : ''">{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ $t(`menu.${item.title}`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <!-- Arrow button for activate drawer -->
      <v-card v-if="!drawer">
        <v-card-text class="text-center">
          <!-- progress bar for limit of free plan -->
          <h3 class="mb-3">
            {{ $auth.user?.role ? $auth.user?.role.toUpperCase() : 'Free' }}
            <!-- info buble -->
            <v-tooltip v-if="!$auth.user?.role" bottom>
              <template v-slot:activator="{ on }">
                <v-icon color="primary" v-on="on">
                  mdi-information
                </v-icon>
              </template>
              <span>
                {{ $t('tooltip.free_plan') }}
              </span>
            </v-tooltip>
          </h3>
          <v-progress-linear :value="user.projects.length * 100 / nbOfProjectsBasedOnPlan" color="primary" height="15">
          </v-progress-linear>

          <span class="white--text ">
            {{ user.projects.length }}/{{ nbOfProjectsBasedOnPlan }} {{ $t('label.projects_created') }}
          </span>
          <v-btn elevation="0" v-if="!$auth.user?.role && !isMobile" block class="mt-3" dense primary to="/plan">
            <span class="mr-2">
              <v-icon color="primary">
                mdi-account
              </v-icon>
            </span>
            <span>{{ $t('button.upgrade_to_basic') }}</span>
          </v-btn>

        </v-card-text>
      </v-card>
    </v-navigation-drawer>

    <v-main class="main-with-bottom-nav">
      <!-- Promo Banner after 10 sessions -->
      <div v-if="showPromoBanner && !isPro" class="promo-banner">
        <div class="promo-spacer"></div>
        <div class="promo-content">
          <v-icon color="white" size="18" class="mr-2">mdi-gift</v-icon>
          <span class="promo-text">Offre speciale : <strong>-20%</strong> sur l'abonnement Pro avec le code</span>
          <span class="promo-code" @click="copyPromoCode">BONUS20</span>
          <v-icon v-if="promoCopied" color="white" size="14" class="ml-1">mdi-check</v-icon>
        </div>
        <v-btn icon x-small dark class="promo-close" @click="dismissPromoBanner">
          <v-icon size="16">mdi-close</v-icon>
        </v-btn>
      </div>
      
      <!-- Free Tier Banner -->
      <FreeTierBanner type="general" :dismissible="true" />
      
      <!-- Social Proof Notifications -->
      <SocialProofBanner />

      <template>
        <v-dialog v-model="choiceRegion" max-width="500">
          <ChangeRegion @close="choiceRegion = false" />
        </v-dialog>
      </template>
      <!-- Alert moderne compacte et flottante pour dépassement de plan (caché sur iOS Capacitor) -->
      <div v-if="user.projects.length >= nbOfProjectsBasedOnPlan && !dismissAlert && !isMobile" class="modern-limit-alert-floating">
        <div class="alert-container-compact">
          <!-- Countdown timer -->
          <div class="alert-timer" :style="{ width: `${(autoCloseTimer / 10) * 100}%` }"></div>
          
          <!-- Contenu compact -->
          <div class="alert-content-compact">
            <div class="alert-icon-compact">
              <v-icon color="#ff6b35" size="18">mdi-alert-circle</v-icon>
            </div>
            
            <div class="alert-text-compact">
              <div class="alert-title-compact">{{ $t('message.limit_reached_alert') }}</div>
              <div class="alert-subtitle-compact">{{ user.projects.length }}/{{ nbOfProjectsBasedOnPlan }} {{ $t('label.projects_created') }}</div>
            </div>
            
            <div class="alert-actions-compact">
              <v-btn 
                x-small
                class="upgrade-compact-btn"
                elevation="0"
                @click="$router.push('/plan')"
              >
                <v-icon left size="12">mdi-rocket-launch</v-icon>
                PRO
              </v-btn>
              
              <v-btn 
                icon 
                x-small 
                class="close-compact-btn"
                :class="{ 'close-compact-btn--disabled': autoCloseTimer > 0 }"
                :disabled="autoCloseTimer > 0"
                @click="dismissAlert = true"
              >
                <v-icon size="12" v-if="autoCloseTimer > 0">{{ autoCloseTimer }}</v-icon>
                <v-icon size="12" v-else>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
          
          <!-- Particules compactes -->
          <div class="alert-effects-compact">
            <div class="alert-particle-compact" v-for="i in 4" :key="i" :style="getAlertParticleStyle(i)"></div>
          </div>
        </div>
      </div>

      <v-container fluid class="pa-0 ma-0">
        <!-- Transition ultra-fluide pour les changements de page -->
        <transition 
          name="page-slide" 
          mode="out-in" 
          :duration="{ enter: 300, leave: 300 }"
          @before-enter="onBeforeEnter"
          @enter="onEnter"
          @leave="onLeave"
        >
          <router-view :key="$route.fullPath" />
        </transition>
      </v-container>

      <!-- Navigation Bottom Moderne -->
      <div v-if="!cinemaMode && $route.path != '/project'" class="modern-bottom-nav">
        <div class="nav-container">
          
          <!-- Navigation principale -->
          <div class="nav-main-items">
            <div 
              v-for="(item, i) in items" 
              :key="i" 
              class="nav-item"
              :class="{ 'nav-item--active': isActiveRoute(item.to) }"
              @click="navigateToRoute(item)"
            >
              <div class="nav-item-content">
                <div class="nav-icon-wrapper">
                  <v-icon 
                    :color="isActiveRoute(item.to) ? 'primary' : 'white'" 
                    :size="isActiveRoute(item.to) ? '24' : '20'"
                    class="nav-icon"
                  >
                    {{ item.icon }}
                  </v-icon>
                  <div v-if="isActiveRoute(item.to)" class="nav-active-indicator"></div>
                </div>
                <span 
                  class="nav-label" 
                  :class="{ 'nav-label--active': isActiveRoute(item.to) }"
                >
                  {{ $t(`menu.${item.title}`) }}
                </span>
              </div>
            </div>
          </div>

          <!-- Bouton Pro flottant (caché sur iOS Capacitor car app payante) -->
          <div v-if="!isPro && !isMobile" class="nav-pro-section" style="z-index:1000!important;">
            <div class="pro-floating-btn" @click="$router.push('/plan')">
              <div class="pro-btn-content">
                <v-icon color="white" size="16" class="mr-1">mdi-star</v-icon>
                <span class="pro-text">PRO</span>
              </div>
              <div class="pro-shine-effect"></div>
            </div>
          </div>
        </div>

        <!-- Indicateur de progression pour utilisateurs gratuits -->
        <div v-if="!isPro && false" class="nav-progress-section">
          <div class="progress-container">
            <div class="progress-info">
              <span class="progress-label">Projets utilisés</span>
              <span class="progress-count">{{ user.projects.length }}/{{ nbOfProjectsBasedOnPlan }}</span>
            </div>
            <div class="progress-bar-container">
              <div 
                class="progress-bar-fill" 
                :style="{ width: `${Math.min((user.projects.length / nbOfProjectsBasedOnPlan) * 100, 100)}%` }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </v-main>
    <!-- IApp désactivé car l'app iOS est payante, pas besoin d'in-app purchase -->
    <IApp v-if="false && iap && isMobile" />
    <v-dialog v-model="popupPlan" max-width="" class="pa-0 ma-0">
      <v-card>
        <v-card-title>
          <v-spacer />
          <v-btn icon @click="popupPlan = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <PlanView @continue-free="popupPlan = false" />
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import { Capacitor } from '@capacitor/core';
import moment from 'moment';
// Imports removed - using lazy loading for better performance

export default {
  name: "App",
  components: {
    ChangeRegion: () => import('./components/ChangeRegion.vue'),
    IApp: () => import('./views/IAppView.vue'),
    // Lazy load all components for better performance
    PlanView: () => import('./views/PlanView.vue'),
    FreeTierBanner: () => import('./components/FreeTierBanner.vue'),
    SocialProofBanner: () => import('./components/SocialProofBanner.vue')
  },
  computed: {
    isMobile() {
      return Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android';
    },
    ...mapState(["user", "region", "cinemaMode"]),
    nbOfProjectsBasedOnPlan() {
      if (this.$auth.user?.role == "basic") {
        return 10;
      }
      else if (this.$auth.user?.role == "pro") {
        return "∞";
      }
      // Utiliser la limite depuis le store (intégration GrowthBook)
      const limits = this.$store.getters.GET_LIMITS;
      return limits ? limits.projectLimit : 2;
    },
    isPro() {
      return this.$auth.user?.role == "pro" || this.$auth.user?.role == "basic";
    }
  },
  data: () => ({
    drawer: true,
    popupPlan: false,
    dismissAlert: false,
    autoCloseTimer: 10,
    value: "new_project",
    showPromoBanner: false,
    promoCopied: false,
    // iap: localStorage.getItem('iap') ? false : true,
    iap: true,
    moment: moment,
    choiceRegion: false,
    // Pre-compute particle styles once for better performance
    particleStyles: [
      {
        left: '20%',
        top: '30%',
        animationDelay: '0.5s',
        animationDuration: '3s'
      },
      {
        left: '70%',
        top: '60%',
        animationDelay: '1.2s',
        animationDuration: '4s'
      },
      {
        left: '45%',
        top: '80%',
        animationDelay: '0.8s',
        animationDuration: '2.5s'
      },
      {
        left: '85%',
        top: '25%',
        animationDelay: '1.8s',
        animationDuration: '3.5s'
      }
    ],
    items: [
      {
        title: "new_project",
        icon: "mdi-filmstrip",
        to: "/"
      },
      {
        title: "workspace",
        icon: "mdi-folder",
        to: "/workspaces"
      },
      // {
      //   title: "catalog",
      //   icon: "mdi-account-group",
      //   to: "/community"
      // },
      {
        title: "profile",
        icon: "mdi-account",
        to: "/settings"
      }
    ],
    // Store interval reference for cleanup
    alertTimerInterval: null
  }),
  mounted() {
    // Gestion de l'affichage du plan (sauf mobile et Pro)
    setTimeout(() => {
      if(!this.isPro && !this.isMobile && this.$auth.isAuthenticated)
      {
        const hasSeenPlan = localStorage.getItem('hasSeenPlan');
        if(!hasSeenPlan && this.$route.path !== '/plan') {
          // Premiere visite: rediriger vers /plan (bloquant)
          this.$router.push({ path: '/plan', query: { first: 'true' } });
        } else if(hasSeenPlan) {
          // Sessions suivantes: afficher popup toutes les 3 sessions
          const sessionCount = parseInt(localStorage.getItem('sessionCount') || '0') + 1;
          localStorage.setItem('sessionCount', String(sessionCount));
          if(sessionCount % 3 === 0) {
            this.popupPlan = true;
          }
          // Afficher la banniere promo apres 10 sessions (chaque session tant que non Pro)
          const promoDismissedThisSession = sessionStorage.getItem('promoBannerDismissed');
          if(sessionCount >= 10 && !promoDismissedThisSession) {
            this.showPromoBanner = true;
          }
        }
      }
    }, 1500);
    // !this.iap ? localStorage.setItem('iap', true) : ''; 
    this.drawer = this.$vuetify.breakpoint.mobile ? false : true;
    if (this.region) {
      this.choiceRegion = false;
      this.$store.dispatch('setRegion', this.region)
    } else {
      this.choiceRegion = true;
    }
    // detect lang 
    var lang = navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage;
    lang = lang.substr(0, 2);
    lang = lang.toLowerCase();
    if (lang == "fr") {
      this.$i18n.locale = "fr";
    }
    else {
      this.$i18n.locale = "en";
    }
    // event bus listen
    this.$bus.$on("updateProjects", () => {
      this.getUserProjects();
    });
    this.$nextTick(() => {
      this.getUserProjects();
    });
    
    // Check if user already exceeded limit and start timer
    this.$nextTick(() => {
      if (this.user.projects && this.user.projects.length >= this.nbOfProjectsBasedOnPlan && !this.dismissAlert) {
        this.startAlertTimer();
      }
    });
    
    window.addEventListener(
      "touchmove",
      function (event) {
        if (event.scale !== 1) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      { passive: false }
    );
  },
  beforeDestroy() {
    // Clean up timer to prevent memory leaks
    if (this.alertTimerInterval) {
      clearInterval(this.alertTimerInterval);
      this.alertTimerInterval = null;
    }
  },
  watch: {
    "$auth.user.sub": function () {
      this.getUserProjects();
    },
    "user.projects.length": {
      handler(newLength, oldLength) {
        // Only start timer if we just reached or exceeded the limit
        // Avoid restarting timer on every project change
        if (newLength >= this.nbOfProjectsBasedOnPlan && 
            oldLength < this.nbOfProjectsBasedOnPlan && 
            !this.dismissAlert) {
          this.startAlertTimer();
        }
      }
    },
    // Watcher pour fermer la popup si l'utilisateur devient Pro
    isPro: function(newVal) {
      if (newVal && this.popupPlan) {
        console.log('[App] User is now Pro, closing plan popup');
        this.popupPlan = false;
      }
    }
  },
  methods: {
    getUserProjects() {
      if (!this.$auth.user.sub)
        return;
      this.$strapi.find("workspaces", {
        populate: "*",
        filters: {
          user: this.$auth.user.sub,
          public: false
        }
      }).then(response => {
        this.$store.dispatch("SET_USER_PROJECTS", response.data);
      }).catch(error => {
        console.log(error);
      });
    },
    isActiveRoute(route) {
      return this.$route.path === route;
    },
    navigateToRoute(item) {
      if (item.title === 'logout') {
        this.logout();
      } else {
        this.$router.push(item.to);
      }
    },
    logout() {
      // Implement the logout logic here
      console.log('Logging out');
    },
    // Use pre-computed styles for better performance
    getAlertParticleStyle(index) {
      return this.particleStyles[index - 1] || this.particleStyles[0];
    },
    copyPromoCode() {
      navigator.clipboard.writeText('BONUS20').then(() => {
        this.promoCopied = true;
        setTimeout(() => {
          this.promoCopied = false;
        }, 2000);
      });
    },
    dismissPromoBanner() {
      this.showPromoBanner = false;
      sessionStorage.setItem('promoBannerDismissed', 'true');
    },
    startAlertTimer() {
      // Clear any existing timer first
      if (this.alertTimerInterval) {
        clearInterval(this.alertTimerInterval);
      }
      
      this.autoCloseTimer = 10;
      
      this.alertTimerInterval = setInterval(() => {
        this.autoCloseTimer--;
        
        if (this.autoCloseTimer <= 0) {
          this.dismissAlert = true;
          clearInterval(this.alertTimerInterval);
          this.alertTimerInterval = null;
        }
      }, 1000);
      
      // Clear interval if user dismisses manually
      const unwatch = this.$watch('dismissAlert', (newVal) => {
        if (newVal && this.alertTimerInterval) {
          clearInterval(this.alertTimerInterval);
          this.alertTimerInterval = null;
          unwatch(); // Stop watching after cleanup
        }
      });
    },
    // ===== MÉTHODES POUR TRANSITIONS DE PAGE - OPTIMIZED =====
    onBeforeEnter(el) {
      // Préparation avant l'entrée avec GPU acceleration
      el.style.opacity = '0';
      el.style.transform = 'translate3d(30px, 0, 0)';
      el.style.willChange = 'transform, opacity';
    },
    onEnter(el, done) {
      // Animation d'entrée simple et fluide
      el.offsetHeight; // Force reflow
      el.style.transition = 'transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.25s ease';
      el.style.opacity = '1';
      el.style.transform = 'translate3d(0, 0, 0)';
      
      setTimeout(() => {
        el.style.willChange = 'auto'; // Reset will-change after animation
        done();
      }, 250);
    },
    onLeave(el, done) {
      // Animation de sortie simple
      el.style.willChange = 'transform, opacity';
      el.style.transition = 'transform 0.2s cubic-bezier(0.55, 0.055, 0.675, 0.19), opacity 0.2s ease';
      el.style.opacity = '0';
      el.style.transform = 'translate3d(-20px, 0, 0)';
      
      setTimeout(() => {
        el.style.willChange = 'auto'; // Reset will-change after animation
        done();
      }, 200);
    }
  },
};
</script>

<style lang="scss">
@import '@/assets/css/pro-theme.css';

$body-font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;

/* Promo Banner */
.promo-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: linear-gradient(90deg, #7c3aed 0%, #a855f7 50%, #7c3aed 100%);
  background-size: 200% 100%;
  animation: promoGradient 3s ease infinite;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(124, 58, 237, 0.3);
}

@keyframes promoGradient {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.promo-spacer {
  width: 40px;
  flex-shrink: 0;
}

.promo-content {
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: center;
}

.promo-text {
  color: white;
  font-size: 13px;
  font-weight: 500;
}

.promo-code {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  font-weight: 700;
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 4px;
  margin-left: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px dashed rgba(255, 255, 255, 0.5);
}

.promo-code:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.promo-close {
  flex-shrink: 0;
  opacity: 0.7;
  margin-left: 16px;
}

.promo-close:hover {
  opacity: 1;
}

/* Ajuster le main quand la banniere promo est visible */
.promo-banner + .main-with-bottom-nav {
  padding-top: 40px !important;
}
$mono-font: 'JetBrains Mono', 'SF Mono', monospace;

.v-application.pro-theme {
  font-family: $body-font-family !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .title, .v-toolbar__title {
    font-family: $body-font-family !important;
    font-weight: 600;
  }
  
  code, .mono {
    font-family: $mono-font !important;
  }
}

.pro-theme.theme--dark.v-application {
  background-color: var(--pro-bg-primary) !important;
}

.pro-theme.theme--dark.v-application::before {
  display: none;
}


.pro-theme .v-navigation-drawer--close {
  visibility: visible !important;
}

.pro-theme nav.v-navigation-drawer,
.pro-theme .v-bottom-navigation {
  bottom: 4px !important;
  box-shadow: var(--pro-shadow-md) !important;
  width: calc(100% - 8px) !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  height: 44px !important;
  background-color: var(--pro-bg-secondary) !important;
  border-radius: var(--pro-radius-md);
  border: 1px solid var(--pro-border-subtle);
  z-index: 1000 !important;
}

.pro-theme .theme--dark.v-tabs > .v-tabs-bar, 
.pro-theme .theme--dark.v-data-table, 
.pro-theme .v-application .dark,
.pro-theme .menu {
  background-color: transparent !important;
  height: var(--pro-tab-height);
}

.pro-theme .v-tab {
  font-size: var(--pro-text-xs) !important;
  font-weight: var(--pro-font-medium) !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
}

.pro-theme .v-application .dark {
  background-color: var(--pro-bg-primary) !important;
}

.pro-theme .v-toolbar {
  background-color: var(--pro-bg-secondary) !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  border-bottom: 1px solid var(--pro-border-subtle);
}

.pro-theme .v-toolbar__content .v-btn--round, 
.pro-theme .v-btn:not(.v-btn--round).v-size--x-small {
  border-radius: var(--pro-radius-default);
  margin-left: 2px;
  margin-right: 2px;
  height: var(--pro-btn-height-sm) !important;
}

.pro-theme .theme--dark.v-toolbar.v-sheet {
  margin: 0;
  background-color: var(--pro-bg-secondary) !important;
  border-radius: 0;
}

.pro-theme .v-navigation-drawer__border {
  display: none;
}

.pro-theme .v-sheet, 
.pro-theme .v-card {
  backface-visibility: hidden;
  background-attachment: fixed;
}

.v-main__wrap {
  /* Force scroll vertical sur le contenu principal */
  overflow-y: auto !important;
  overflow-x: hidden !important;
  /* Réserver l'espace pour la bottom-nav fixe (élément réellement scrollable de Vuetify) */
  padding-bottom: calc(140px + env(safe-area-inset-bottom, 0px));
}

/* Réserve un espace en bas pour la bottom-nav fixe sur toutes les vues */
.main-with-bottom-nav { /* garde une marge de sécurité supplémentaire si d'autres vues ne scrollent pas sur wrap */
  padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));
}


.video-preview:hover {
  background-image: linear-gradient(90deg, #8468923d, #e0c9eb36);
  padding: 1px;
  border-radius: 8px;
  height: 100%;
  transition: all 0.3s ease-in;
}

/* animation */
.video-preview {
  background-image: none;
  padding: 5px;
  border-radius: 8px;
  height: 100%;
  margin-bottom: 1em;
  transition: all 1s ease-out;
}

.introjs-arrow.top {
  display: none !important;
}

.v-btn > .v-btn__content .v-icon {
    filter: contrast(0.5)!important;
}

.v-menu__content {
    z-index: 1000!important;
}

// blink animation
.blink {
  animation: blinker 1s linear infinite;
}

/* ===== NAVIGATION BOTTOM PRO ===== */

.pro-theme .modern-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  padding: 4px 6px 6px;
  pointer-events: none;
  height: 72px;
  overflow: visible;
}

.pro-theme .nav-container {
  background: var(--pro-bg-secondary);
  border-radius: var(--pro-radius-md);
  border: 1px solid var(--pro-border-subtle);
  box-shadow: var(--pro-shadow-md);
  padding: 6px 10px;
  pointer-events: all;
  position: relative;
  overflow: visible;
  transform: translateZ(0);
}

/* Navigation principale */
.pro-theme .nav-main-items {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 2px;
}

/* Items de navigation PRO */
.pro-theme .nav-item {
  flex: 1;
  cursor: pointer;
  transition: all var(--pro-transition-default);
  border-radius: var(--pro-radius-default);
  padding: 4px 2px;
  position: relative;
  overflow: hidden;
}

.pro-theme .nav-item:hover {
  background: var(--pro-bg-hover);
}

.pro-theme .nav-item--active {
  background: rgba(59, 130, 246, 0.1);
}

/* Contenu des items */
.pro-theme .nav-item-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  position: relative;
  z-index: 2;
}

/* Wrapper des icones */
.pro-theme .nav-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: var(--pro-radius-default);
  transition: all var(--pro-transition-default);
  contain: layout style paint;
}

.pro-theme .nav-item--active .nav-icon-wrapper {
  background: rgba(59, 130, 246, 0.15);
}

/* Icones */
.pro-theme .nav-icon {
  transition: transform var(--pro-transition-default);
  font-size: 16px !important;
}

.pro-theme .nav-item--active .nav-icon {
  transform: scale(1.02);
}

/* Indicateur actif PRO */
.pro-theme .nav-active-indicator {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 5px;
  height: 5px;
  background: var(--pro-accent-primary);
  border-radius: 50%;
}

/* Labels de navigation */
.pro-theme .nav-label {
  font-size: 10px;
  font-weight: var(--pro-font-medium);
  color: var(--pro-text-tertiary);
  transition: all var(--pro-transition-default);
  text-align: center;
  line-height: 1.1;
}

.pro-theme .nav-label--active {
  color: var(--pro-accent-primary);
  font-weight: var(--pro-font-semibold);
}

/* Section Pro */
.pro-theme .nav-pro-section {
  position: absolute;
  top: -20px;
  right: 12px;
  z-index: 1100 !important;
  pointer-events: all;
}

.pro-theme .pro-floating-btn {
  background: var(--pro-accent-pro);
  border-radius: var(--pro-radius-default);
  padding: 4px 10px;
  box-shadow: var(--pro-shadow-md);
  cursor: pointer;
  transition: all var(--pro-transition-default);
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(139, 92, 246, 0.3);
}

.pro-theme .pro-floating-btn:hover {
  background: #7c3aed;
  box-shadow: var(--pro-shadow-lg);
}

.pro-theme .pro-btn-content {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 2;
}

.pro-theme .pro-text {
  font-size: 10px;
  font-weight: var(--pro-font-semibold);
  color: white;
  letter-spacing: 0.02em;
}

.pro-theme .pro-shine-effect {
  display: none;
}

/* Section de progression */
.pro-theme .nav-progress-section {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid var(--pro-border-subtle);
}

.pro-theme .progress-container {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.pro-theme .progress-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pro-theme .progress-label {
  font-size: var(--pro-text-xs);
  color: var(--pro-text-tertiary);
  font-weight: var(--pro-font-medium);
}

.pro-theme .progress-count {
  font-size: var(--pro-text-xs);
  color: var(--pro-accent-primary);
  font-weight: var(--pro-font-semibold);
}

.pro-theme .progress-bar-container {
  height: 2px;
  background: var(--pro-bg-hover);
  border-radius: 1px;
  overflow: hidden;
  position: relative;
}

.pro-theme .progress-bar-fill {
  height: 100%;
  background: var(--pro-accent-primary);
  border-radius: 1px;
  transition: width var(--pro-transition-slow);
  position: relative;
}

/* Responsive Design PRO */
@media (max-width: 768px) {
  .pro-theme .modern-bottom-nav {
    padding: 3px 4px 4px;
  }
  
  .pro-theme .nav-container {
    border-radius: var(--pro-radius-md);
    padding: 4px 8px;
  }
  
  .pro-theme .nav-item {
    padding: 3px 1px;
  }
  
  .pro-theme .nav-icon-wrapper {
    width: 22px;
    height: 22px;
  }
  
  .pro-theme .nav-label {
    font-size: 9px;
  }
  
  .pro-theme .pro-floating-btn {
    padding: 4px 8px;
  }
  
  .pro-theme .pro-text {
    font-size: 9px;
  }
}

/* ===== ALERT PRO ===== */
.pro-theme .modern-limit-alert-floating {
  position: fixed;
  top: 60px;
  right: 16px;
  z-index: 1001;
  width: 260px;
  animation: alertSlideIn 0.2s ease-out;
}

@keyframes alertSlideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.pro-theme .alert-container-compact {
  background: var(--pro-bg-elevated);
  border-radius: var(--pro-radius-md);
  border: 1px solid rgba(245, 158, 11, 0.3);
  box-shadow: var(--pro-shadow-lg);
  overflow: hidden;
  position: relative;
  transform: translateZ(0);
}

/* Timer de countdown */
.pro-theme .alert-timer {
  height: 2px;
  background: var(--pro-accent-warning);
  transition: width 1s linear;
  position: absolute;
  top: 0;
  left: 0;
}

/* Contenu compact */
.pro-theme .alert-content-compact {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  position: relative;
  z-index: 2;
}

/* Icone compacte */
.pro-theme .alert-icon-compact {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: rgba(245, 158, 11, 0.1);
  border-radius: var(--pro-radius-default);
  flex-shrink: 0;
}

/* Texte compact */
.pro-theme .alert-text-compact {
  flex: 1;
  min-width: 0;
}

.pro-theme .alert-title-compact {
  font-size: var(--pro-text-sm);
  font-weight: var(--pro-font-semibold);
  color: var(--pro-text-primary);
  margin-bottom: 2px;
  line-height: 1.2;
}

.pro-theme .alert-subtitle-compact {
  font-size: var(--pro-text-xs);
  color: var(--pro-text-secondary);
  line-height: 1.2;
}

/* Actions compactes */
.pro-theme .alert-actions-compact {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.pro-theme .upgrade-compact-btn {
  background: var(--pro-accent-warning) !important;
  color: white !important;
  border-radius: var(--pro-radius-default) !important;
  text-transform: none !important;
  font-weight: var(--pro-font-semibold) !important;
  font-size: var(--pro-text-xs) !important;
  min-width: 44px !important;
  height: 24px !important;
  transition: all var(--pro-transition-default) !important;
}

.pro-theme .upgrade-compact-btn:hover {
  background: #d97706 !important;
}

.pro-theme .close-compact-btn {
  background: var(--pro-bg-hover) !important;
  border-radius: var(--pro-radius-default) !important;
  width: 22px !important;
  height: 22px !important;
  transition: all var(--pro-transition-default) !important;
}

.pro-theme .close-compact-btn:hover {
  background: var(--pro-bg-surface) !important;
}

.pro-theme .close-compact-btn--disabled {
  background: rgba(245, 158, 11, 0.1) !important;
  color: var(--pro-accent-warning) !important;
  cursor: not-allowed !important;
  opacity: 0.8 !important;
}

.pro-theme .close-compact-btn--disabled:hover {
  background: rgba(245, 158, 11, 0.1) !important;
}

.pro-theme .close-compact-btn--disabled .v-icon {
  color: var(--pro-accent-warning) !important;
  font-size: 10px !important;
}

/* Particules - desactivees pour PRO */
.pro-theme .alert-effects-compact {
  display: none;
}

.pro-theme .alert-particle-compact {
  display: none;
}

/* Responsive pour alerte compacte */
@media (max-width: 768px) {
  .modern-limit-alert-floating {
    top: 70px;
    right: 12px;
    left: 12px;
    width: auto;
  }
  
  .alert-content-compact {
    padding: 10px 14px;
    gap: 10px;
  }
  
  .alert-icon-compact {
    width: 28px;
    height: 28px;
  }
  
  .alert-title-compact {
    font-size: 12px;
  }
  
  .alert-subtitle-compact {
    font-size: 10px;
  }
  
  .upgrade-compact-btn {
    min-width: 45px !important;
    height: 26px !important;
    font-size: 10px !important;
  }
  
  .close-compact-btn {
    width: 22px !important;
    height: 22px !important;
  }
}

@media (max-width: 480px) {
  .modern-limit-alert-floating {
    top: 60px;
    right: 8px;
    left: 8px;
  }
  
  .alert-content-compact {
    padding: 8px 12px;
  }
}

/* ===== TRANSITIONS PRO ===== */

.pro-theme .page-slide-enter-active {
  transition: all 0.15s ease-out;
}

.pro-theme .page-slide-leave-active {
  transition: all 0.1s ease-in;
}

.pro-theme .page-slide-enter {
  opacity: 0;
  transform: translateX(16px);
}

.pro-theme .page-slide-leave-to {
  opacity: 0;
  transform: translateX(-8px);
}

.pro-theme .page-slide-enter-active,
.pro-theme .page-slide-leave-active {
  backface-visibility: hidden;
  will-change: transform, opacity;
  transform: translate3d(0, 0, 0);
}

@media (max-width: 768px) {
  .pro-theme .page-slide-enter-active {
    transition: all 0.12s ease-out;
  }
  
  .pro-theme .page-slide-leave-active {
    transition: all 0.08s ease-in;
  }
  
  .pro-theme .page-slide-enter {
    transform: translateX(12px);
  }
  
  .pro-theme .page-slide-leave-to {
    transform: translateX(-6px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .pro-theme .page-slide-enter-active,
  .pro-theme .page-slide-leave-active {
    transition: opacity 0.05s ease;
  }
  
  .pro-theme .page-slide-enter,
  .pro-theme .page-slide-leave-to {
    transform: none;
  }
}

/* ===== DÉSACTIVER LA SÉLECTION DE TEXTE SUR MOBILE ===== */
/* Empêche la sélection de texte indésirable sur l'app mobile */
* {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Réactiver la sélection pour les éléments de saisie */
input,
textarea,
[contenteditable="true"],
.v-text-field input,
.v-textarea textarea {
  -webkit-user-select: text !important;
  -khtml-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
}

/* Empêcher le zoom double-tap sur iOS */
button,
a,
.v-btn {
  touch-action: manipulation;
}

/* Empêcher le comportement de longue pression sur iOS */
img,
a {
  -webkit-touch-callout: none;
}
</style>